import { render, staticRenderFns } from "./AffiliateLink.vue?vue&type=template&id=1d307816&scoped=true"
import script from "./AffiliateLink.vue?vue&type=script&lang=js"
export * from "./AffiliateLink.vue?vue&type=script&lang=js"
import style0 from "./AffiliateLink.vue?vue&type=style&index=0&id=1d307816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d307816",
  null
  
)

export default component.exports